import { useEffect, useState } from 'react';
import styled from 'styled-components';
import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import { AppStatus } from '../AppStatus';
import { LoanStatus } from '../LoanStatus';

type TInputStatus<Fields extends FieldValues> = {
  name?: Path<Fields>;
  checked?: boolean;
  status: string;
  type: 'application' | 'loan';
  reset: boolean; //used so when reset button clicked, checkboxes checked values are false
  register?: UseFormRegister<Fields>;
};

const CheckLabel = styled.label`
  display: block;
  position: relative;
  margin: 15px 6px;

  @media (hover: hover) {
    &:hover {
      span {
        cursor: pointer;
        opacity: 0.85;
      }
    }
  }
`;

const CheckInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const InputStatus = <Fields extends FieldValues>({
  name,
  checked = false,
  status,
  type,
  register,
  reset
}: TInputStatus<Fields>) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [reset]);

  const handleChange = (e: React.MouseEvent<HTMLInputElement>) => {
    setIsChecked(e.currentTarget.checked);
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const registerFunc = register ? register : () => {};

  return (
    <CheckLabel>
      <CheckInput
        type="checkbox"
        name={name}
        value={status}
        checked={isChecked}
        onClick={(e) => handleChange(e)}
        {...registerFunc((name || 'statuses') as Path<Fields>)}
      />
      {type === 'application' ? (
        <AppStatus statusText={status} alternative={!isChecked} />
      ) : (
        <LoanStatus statusText={status} alternative={!isChecked} />
      )}
    </CheckLabel>
  );
};

export { InputStatus };
